import { Component, OnInit, ViewChild, ElementRef, Renderer2, AfterViewInit, HostListener } from '@angular/core';

declare let $;

@Component({
  selector: 'app-mscan-page',
  templateUrl: './mscan-page.component.html',
  styleUrls: ['./mscan-page.component.scss']
})
export class MscanPageComponent implements OnInit, AfterViewInit {

  @ViewChild('homeSection') homeSection: ElementRef;
  @ViewChild('homeTriang') homeTriang: ElementRef;
  @ViewChild('homeImage') homeImage: ElementRef;
  @ViewChild('homeText') homeText: ElementRef;
  @ViewChild('challengeSection') challengeSection: ElementRef;
  @ViewChild('foryouSection') foryouSection: ElementRef;
  @ViewChild('foryouImage') foryouImage: ElementRef;
  @ViewChild('foryouText') foryouText: ElementRef;
  @ViewChild('functionalitiesSection') functionalitiesSection: ElementRef;

  @ViewChild('customerBenefitsSection') customerBenefitsSection: ElementRef;
  @ViewChild('customerBenefitsImage') customerBenefitsImage: ElementRef;
  @ViewChild('customerBenefitsText') customerBenefitsText: ElementRef;
  @ViewChild('storeImages') storeImages: ElementRef;
  @ViewChild('storeBubble1') storeBubble1: ElementRef;
  @ViewChild('storeBubble2') storeBubble2: ElementRef;
  @ViewChild('storeBubble3') storeBubble3: ElementRef;
  @ViewChild('storeBubble4') storeBubble4: ElementRef;
  @ViewChild('benefitsSection') benefitsSection: ElementRef;
  @ViewChild('benefitsImage') benefitsImage: ElementRef;
  @ViewChild('mainComponentsText') mainComponentsSection: ElementRef;
  @ViewChild('mainComponentsText') mainComponentsText: ElementRef;
  @ViewChild('mainComponentsImage') mainComponentsImage: ElementRef;

  constructor(private renderer: Renderer2) { }

  ngOnInit() {
    window.scrollTo(0, 0);
  }

  ngAfterViewInit() {
    this.homeScreenLaying();
    this.renderer.addClass(this.homeTriang.nativeElement, 'fadeInDown');
    this.renderer.addClass(this.homeImage.nativeElement, 'fadeInLeft');
    this.renderer.addClass(this.homeText.nativeElement, 'fadeIn');
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollPosition = window.pageYOffset;

    if ( scrollPosition >= this.challengeSection.nativeElement.offsetTop - window.innerHeight) {
      this.renderer.addClass(this.challengeSection.nativeElement, 'show');
      this.renderer.addClass(this.challengeSection.nativeElement, 'fadeIn');
    }
    if ( scrollPosition >= this.foryouSection.nativeElement.offsetTop - window.innerHeight) {
      this.renderer.addClass(this.foryouSection.nativeElement, 'show');
      this.renderer.addClass(this.foryouText.nativeElement, 'fadeIn');
      this.renderer.addClass(this.foryouImage.nativeElement, 'fadeInRight');
    }
    if ( scrollPosition >= this.functionalitiesSection.nativeElement.offsetTop - window.innerHeight) {
      this.renderer.addClass(this.functionalitiesSection.nativeElement, 'show');
      this.renderer.addClass(this.functionalitiesSection.nativeElement, 'fadeIn');
    }
    if ( scrollPosition >= this.customerBenefitsSection.nativeElement.offsetTop - window.innerHeight) {
      this.renderer.addClass(this.customerBenefitsSection.nativeElement, 'show');
      this.renderer.addClass(this.customerBenefitsSection.nativeElement, 'fadeIn');
      // setTimeout(
      //   () => {
      //     this.renderer.addClass(this.storeBubble1.nativeElement, 'show');
      //     this.renderer.addClass(this.storeBubble1.nativeElement, 'fadeIn');
      //   }, 750 );
      // setTimeout(
      //   () => {
      //     this.renderer.addClass(this.storeBubble2.nativeElement, 'show');
      //     this.renderer.addClass(this.storeBubble2.nativeElement, 'fadeIn');
      //   }, 1000 );
      // setTimeout(
      //   () => {
      //     this.renderer.addClass(this.storeBubble3.nativeElement, 'show');
      //     this.renderer.addClass(this.storeBubble3.nativeElement, 'fadeIn');
      //   }, 1250 );
      // setTimeout(
      //   () => {
      //     this.renderer.addClass(this.storeBubble4.nativeElement, 'show');
      //     this.renderer.addClass(this.storeBubble4.nativeElement, 'fadeIn');
      //   }, 1500 );

     }
    if ( scrollPosition >= this.benefitsSection.nativeElement.offsetTop - window.innerHeight) {
      this.renderer.addClass(this.benefitsSection.nativeElement, 'show');
      this.renderer.addClass(this.benefitsSection.nativeElement, 'fadeIn');
      this.renderer.addClass(this.benefitsImage.nativeElement, 'show');
      this.renderer.addClass(this.benefitsImage.nativeElement, 'fadeInLeft');
    }
    if ( scrollPosition >= this.mainComponentsSection.nativeElement.offsetTop - window.innerHeight) {
      this.renderer.addClass(this.mainComponentsText.nativeElement, 'fadeIn');
      this.renderer.addClass(this.mainComponentsImage.nativeElement, 'fadeInRight');
    }
  }

  private homeScreenLaying() {
    const screenHeight = window.innerHeight;
    $('#blank').height(screenHeight * 0.1);
    $('#content').height(screenHeight * 0.9);
  }

}
